export enum CriteriaSearchZone {
	Subject = 0,
	Body = 1,
	Attachment = 2,
}
